﻿function SetLastActivityTime()
{
    StorageUtils.saveToStorage('LAST_ACTIVITY_TIME', (new Date()).getTime(), localStorage);
}

function getLastActivityTime()
{
    return StorageUtils.getFromStorage('LAST_ACTIVITY_TIME', localStorage);
}

document.addEventListener('touchstart',
    function (e)
    {
        SetLastActivityTime();
    },
    false);

document.addEventListener('mousemove',
    function(e)
    {
        SetLastActivityTime();
    },
    false);

window.SetLastActivityTime = SetLastActivityTime;
window.getLastActivityTime = getLastActivityTime;